import { Typo } from "@pepperstone/pepper-ui-kit";
import { ReactNode } from "react";

export const TableTitle = ({
  title,
  exportToCSV,
}: {
  title?: string;
  exportToCSV?: ReactNode | (() => ReactNode);
}) => {
  return (
    <div className="flex flex-row items-center justify-between pb-4">
      <Typo elem="h3" size="sm" type="heading">
        {title}
      </Typo>
      {exportToCSV &&
        (typeof exportToCSV === "function" ? exportToCSV() : exportToCSV)}
    </div>
  );
};
